import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的活动页管理ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  title: [
    {required: true, message: '活动名称不能为空', trigger: 'blur'},
    {min: 2, max: 16, message: '活动名称长度应为2到16个字符', trigger: 'blur'},
  ],
  starttime: [
    {required: true, message: '活动开始时间不能为空', trigger: 'blur'},
  ],
  endtime: [
    {required: true, message: '活动结束时间不能为空', trigger: 'blur'},
    {validator: this.endtimeValidator, trigger: 'blur'},
  ],
  skip_time: [
    {required: true, message: '跳过时间不能为空', trigger: 'blur'},
    {validator: this.positiveIntegerValidator, trigger: 'blur'},
  ],
  activity_url: [
    {required: true, message: '活动添加链接不能为空', trigger: 'blur'},
  ],
  img_url: [
    {required: true, message: '上传图片不能为空', trigger: 'blur'},
  ],
}




// WEBPACK FOOTER //
// ./src/views/launch-page-activity/launch-page-activity.rules.js